import * as React from 'react';
import { useSettingsContext } from '../contexts/settings';
import Default from './cards/Default';
import ProviderResource from './cards/ProviderResource';

const PostsGrid = ({ posts, setLoadingHeight }) => {
	const tableRef = React.useRef(false);
	const settings = useSettingsContext();

	React.useEffect(() => {
		if (tableRef.current.offsetHeight) {
			setLoadingHeight(`${tableRef.current.offsetHeight}px`);
		} else {
			setLoadingHeight(null);
		}
	}, [posts]);

	if (posts.length) {
		return (
			<div
				ref={tableRef}
				className={`row pfa-posts-grid pfa-posts-grid--${settings.postType}`}
			>
				{posts.map((post) => {
					switch (post.post_type) {
						case 'provider_resource': {
							return <ProviderResource post={post} key={post.ID} />;
						}
						default: {
							return <Default post={post} key={post.ID} />;
						}
					}
				})}
			</div>
		);
	}
};

PostsGrid.displayName = 'PostsGrid';

export default PostsGrid;
